import type { FC, ReactNode } from 'react'

import { Plus } from 'lucide-react'

const QUESTIONS: Array<{ question: string, answer: string }> = [
    {
        question: 'What counts as an active deal?',
        answer: 'Any transaction between accepted offer and closing. Once a deal closes or falls through, it stops counting toward your plan.'
    },
    {
        question: 'Does Closewell replace my transaction coordinator?',
        answer: 'No. Closewell takes the repetitive follow-ups off their plate so one coordinator can support more agents. Plenty of teams use both.'
    },
    {
        question: 'Will Closewell message my clients without me?',
        answer: 'Only if you tell it to. By default every outgoing message waits in your approval queue, and you decide which kinds of updates can go out on their own.'
    },
    {
        question: 'Which contracts can Closewell read?',
        answer: 'Standard state association purchase agreements, counteroffers and addenda, plus most custom forms. When a page cannot be read with confidence, Closewell asks a person instead of guessing.'
    },
    {
        question: 'What happens during the pilot?',
        answer: 'We set Closewell up on one of your live deals and run it alongside your current process, so you can compare the two before you change anything.'
    }
]

export const PricingFaq: FC = (): ReactNode => {
    return (
        <section id='faq' aria-labelledby='faq-title' className='mx-auto max-w-3xl px-5 pt-28 sm:pt-36'>
            <h2 id='faq-title' className='reveal text-center font-heading text-[clamp(2.75rem,5.6vw,4.5rem)] leading-[0.98] tracking-[-0.03em] text-foreground'>
                Questions,
                <span className='italic'> answered</span>
            </h2>

            <div className='mt-12 divide-y divide-border border-y border-border'>
                {QUESTIONS.map((item, index) => (
                    <details key={item.question} className={`reveal reveal-d${Math.min(index + 1, 6)} group`}>
                        <summary className='flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-left text-[17px] font-medium text-foreground transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-4 focus-visible:ring-offset-background [&::-webkit-details-marker]:hidden'>
                            {item.question}

                            <Plus aria-hidden='true' className='size-5 shrink-0 text-mist transition-[rotate,color] duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-open:rotate-[135deg] group-open:text-foreground' />
                        </summary>

                        <p className='max-w-2xl animate-in pb-6 text-[15px] leading-relaxed text-muted-foreground duration-500 ease-out fade-in slide-in-from-top-2'>
                            {item.answer}
                        </p>
                    </details>
                ))}
            </div>
        </section>
    )
}
